import { Globe2, Mic, Users, PenLine } from "lucide-react";
import { ESITO_LABEL, STATO_LABEL } from "@/lib/api";

const ESITO_CLS = {
  aperto: "border-cyan-400/40 bg-cyan-400/10 text-cyan-300",
  chiuso: "border-violet-400/40 bg-violet-400/10 text-violet-300",
  risolto: "border-pink-400/40 bg-pink-400/10 text-pink-300",
};

export function EsitoBadge({ esito }) {
  return <span className={`rounded-full border px-2.5 py-0.5 text-xs font-bold ${ESITO_CLS[esito] || ""}`}>{ESITO_LABEL[esito] || esito}</span>;
}

export function StatoBadge({ stato }) {
  const cls = stato === "pubblicato" ? "border-emerald-400/40 text-emerald-300" : "border-amber-400/40 text-amber-300";
  return <span className={`rounded-full border px-2.5 py-0.5 text-xs font-bold ${cls}`}>{STATO_LABEL[stato] || stato}</span>;
}

const ORIGIN = {
  mondo: [Globe2, "Dal mondo", "text-cyan-300 bg-cyan-400/10"],
  lumacofono: [Mic, "La teoria di Lumacofono", "text-violet-200 bg-violet-500/20"],
  community: [Users, "Community", "text-pink-300 bg-pink-400/10"],
  redazionale: [PenLine, "Ipotesi editoriale · da documentare", "text-amber-300 bg-amber-400/10"],
  da_documentare: [PenLine, "Ipotesi editoriale · da documentare", "text-amber-300 bg-amber-400/10"],
};

export function OriginBadge({ tipo }) {
  const [Icon, label, cls] = ORIGIN[tipo] || ORIGIN.redazionale;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold ${cls}`}>
      <Icon size={12} /> {label}
    </span>
  );
}

export function originsOf(t) {
  return [...new Set((t.attribuzioni || []).map((a) => a.tipo))];
}
